import { ButtonGroup } from "components/ButtonGroup";

const ButtonGroupField = ({
  haveError,
  helpers,
  field,
  form,
  onChange,
  ...restProps
}: any) => {
  const handleChange = (value: string) => {
    helpers.setValue(value);

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <ButtonGroup
      {...restProps}
      haveError={haveError}
      name={field.name}
      value={field.value}
      onChange={handleChange}
    />
  );
};

export default ButtonGroupField;